export const Bio = {
  name: "Najoua Bentaher",
  roles: ["Full-Stack Developer", "Specializing on Web Applications", "Data Engireer","Creating Innovative Solutions", "Programmer"],
  description:[
    "Passionate Full Stack Developer who enjoys building clean and efficient web applications. curious about learning new skills, tools and concepts.",
    "I have worked on both solo projects and collaborative teams, strengthening my communication and problem-solving skills."],
  github: "https://www.linkedin.com/in/najoua-bentaher/",
  resume: "https://drive.google.com/file/d/1rDv1F5Ihrabvp16HxHy0_OuLA79YdCER/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/najoua-bentaher/",
  insta: "https://www.instagram.com/najoua.bentaher/",
  facebook: "https://www.facebook.com/najwa.bentaher.92",
  gmail: "najouabentaher.tech@gmail.com",
}

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "Angular",
        image: "https://angular.io/assets/images/logos/angular/angular.svg",
      },
      {
        name: "React Js",
        image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Tailwind CSS",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "JQuery",
        image: "https://tse1.mm.bing.net/th/id/OIP.BxNFQE_tKp5YJ8XVx9PAdgHaGQ?cb=ucfimg2&ucfimg=1&rs=1&pid=ImgDetMain&o=7&rm=3",
      },
      {
        name: "Bootstrap",
        image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Laravel",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Laravel.svg",
      },
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "C++",
        image: "https://freepnglogo.com/images/all_img/c-logo-a2fa.png",
      },
      {
        name: "JAVA",
        image: "https://static.vecteezy.com/system/resources/previews/022/100/214/original/java-logo-transparent-free-png.png",
      }
    ],
  },
  {
    title: "AI & Machine Learning",
    skills: [
      {
        name: "Machine Learning",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Hey_Machine_Learning_Logo.png",
      },
      {
        name: "Fine-tuning",
        image: "https://www.svgrepo.com/show/452210/git.svg",
      },
      {
        name: "Roboflow",
        image: "https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_31e72694f0d710c089d80c4a6c1ef480/roboflow.png",
      },
    ],
  },
  {
    title: "Automation & Cloud",
    skills: [
      {
        name: "Docker",
        image: "https://www.docker.com/wp-content/uploads/2022/03/Moby-logo.png",
      },
      {
        name: "Selenium",
        image: "https://media.licdn.com/dms/image/C5112AQFqMIvHhVMQsA/article-cover_image-shrink_600_2000/0/1568479161985?e=2147483647&v=beta&t=e8PCajo0UO2vbsxwhrlPoz36uE6bIGKuV4326_QLP9Q",
      },
      {
        name: "IMacros",
        image: "https://axiom.ai/automate-images/imacro-logo.png",
      },
      {
        name: "VirtuableBox",
        image: "https://www.crackedthecode.co/hacking-into-a-20-year-old-tivo/part-2/virtualbox_cover.png",
      },
      {
        name: "GitHub Actions",
        image: "https://github.githubassets.com/images/modules/site/features/actions-icon-actions.svg",
      },
      {
        name: "Linux",
        image: "https://upload.wikimedia.org/wikipedia/commons/3/35/Tux.svg",
      },
      {
        name: "Google Colab",
        image: "https://toponets.github.io/webpage_assets/colab.png",
      }
    ],
  },
  {
    title: "Project Management & Collaboration",
    skills: [
      {
        name: "Trello",
        image: "https://th.bing.com/th/id/R.f41ffef6dd2f3744aa0701d008fa9b5c?rik=PEja6Fk1gYbdyA&riu=http%3a%2f%2fpluspng.com%2fimg-png%2ftrello-png-trello-png-1600.png&ehk=%2f5HsDWOmVOq2MCOeegOW7jxi%2fW0vlirVOmouZoxwyIs%3d&risl=&pid=ImgRaw&r=0",
      },
      {
        name: "Scrum",
        image: "https://cdn.worldvectorlogo.com/logos/scrum-1.svg",
      },
      {
        name: "Odoo",
        image: "https://download.odoo.co.th/images/odoo-logo.png",
      },
      {
        name: "Power BI",
        image: "https://cdn.freelogovectors.net/wp-content/uploads/2023/11/power-bi-logo-freelogovectors.net_.png",
      },
      {
        name: "Git",
        image: "https://www.svgrepo.com/show/452210/git.svg"      
      },
      {
        name: "GitHub",
        image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "BitBucket",
        image: "https://help.squiz.net/__data/assets/image/0013/643/Bitbucket.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "VS Code",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Shell",
        image:"https://iconape.com/wp-content/png_logo_vector/bash-shell-logo.png",
      },
      {
        name: "Crontab GURU",
        image: "https://www.solvetic.com/uploads/monthly_02_2018/ccs-7463-0-69670300-1517825569.png",
      },
      {
        name: "Postman",
        image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Airflow",
        image: "https://iconape.com/wp-content/files/dd/370523/svg/airflow-logo-icon-png-svg.png",
      },
      {
        name: "XML",
        image: "https://cdn.freelogovectors.net/wp-content/uploads/2021/02/xml_logo-freelogovectors.net_.png",
      }
    ],
  },
]

export const experiences = [
  {
    id: 0,
    image: "onetechma_logo_1.jpeg",
    role: "IT Developer",
    company: "EIN CONSULTING",
    date: "Sept 2023 - Present",
    location: "Tangier, Morocco",
    desc: "Development, updating, and integration of web interfaces and APIs according to business requirements, with a focus on process optimization and performance improvement, creation and automation of data processing and insertion scripts to streamline workflows and ensure data accuracy",
    skills: ["Laravel", "PHP", "Python", "JavaScript", "Selenium", "PostgreSQL", "Airflow", "DNS/DHCP", "Linux", "Automation","Git",],
  },
  {
    id: 1,
    image: "onetechma_logo_1.jpeg", // You may need to add the actual logo file
    role: "Internship PFE",
    company: "EIN CONSULTING",
    date: "June 2025 - August 2025",
    location: "Tangier, Morocco",
    desc: "Development of an intelligent service for automatic reCAPTCHA resolution using pre-trained models for image recognition.",
    skills: ["Python", "Selenium", "Tensrflow", "Flask", "Roboflow", "HuggingFace"],
  },
  {
    id: 2,
    image: "leader_gestion.png", // You may need to add the actual logo file
    role: "Internship PFE",
    company: "LiDER Gestion",
    date: "Apr 2023 – Jun 2023",
    location: "Tetouane, Morocco",
    desc: "Development of a full-stack web application to manage, view and calculate taxes on undeveloped urban land.",
    skills: ["Laravel", "MySQL", "Angular", "API REST FULL", "Git", "GitHub"],
   
  },
  {
    id: 3,
    role: "Assistance Support",
    company: "Service Maroc",
    date: "June 2021 - August 2021",
    location: "Distance",
    desc: "Providing support and assistance in managing products on PrestaShop, including updating product listings and optimizing content for SEO and search engine ranking to improve visibility and online performance..",
    skills: ["PrestaShop", "Excel"],
  },
]

export const certificates = [
  {
    id: 1,
    title: "HTML, CSS, and Javascript for Web Developers",
    issuer: "Coursera",
    date: "November 2022",
    description: "Completed a comprehensive foundational skills in building responsive and interactive web pages using HTML, CSS, and JavaScript.",
    img: "1715083442192.jpeg",
  },
  {
    id: 2,
    title: "Problem-solving techniques",
    issuer: "LinkedIn",
    date: "August 2023",
    description: "Certification demonstrating the ability to apply structured problem-solving techniques to analyze challenges and develop effective, scalable solutions.",
    img: "Screenshot from 2024-10-31 23-30-53.png",
  },
  {
    id: 3,
    title: "Fundamentals of digital marketing",
    issuer: "Google",
    date: "August 2023",
    description: "Certification validating core skills in digital marketing, including SEO, analytics, content strategy, and online advertising fundamentals",
    img: "Screenshot from 2024-10-31 23-33-39.png",
  },
  {
    id: 4,
    title: "ALX AiCE - AI Career Essentials",
    issuer: "ALX Africa ",
    date: "June 2024 - July 2024",
    description: "Certification demonstrating foundational skills in AI concepts, data literacy, prompt engineering, and the practical use of AI tools for real-world problem-solving.",
    img: "aws-certified-cloud-practitioner.png",
  },
  {
    id: 5,
    title: "Astronomer Certification for Apache Airflow 3 Fundamentals",
    issuer: "Astronomer",
    date: "October 2025",
    description: "Certification validating essential skills in Apache Airflow 3, including DAG creation, scheduling, task orchestration, and workflow management best practices.",
    img: "blob_1.png",
  },
  {
    id: 6,
    title: "Astronomer Certification DAG Authoring for Apache Airflow 3",
    issuer: "Astronomer",
    date: "October 2025",
    description: "Certification demonstrating proficiency in authoring, optimizing, and managing Airflow DAGs using best practices for scalable and reliable workflow orchestration.",
    img: "blob.png",
  },
];

export const education = [
  {
    id: 0,
    img: "ensa.png",
    school: "National School of Applied Sciences in Tangier",
    date: "2023 - 2025",
    desc: "I earned a Higher Specialized Studies diploma with emphasis on data engineering, software development and system architectures",
    degree: "Computer Engineering, Security and Decision",
  },
   {
    id: 1,
    img: "fst.png",
    school: "Faculty of Science and Technology in Tangier",
    date: "2022 - 2023",
    desc: "I completed my bachelor's degree program on software development and computer Engineering",
    degree: "Computer Engineering",
  },
  {
    id: 2,
    img: "fst.png",
    school: "Faculty of Science and Technology in Tangier",
    date: "2018 - 2022",
    desc: "I completed a two-year preparatory cycle (DEUST), covering mathematics, physics, chemistry, and basic computer science (MIPC).",
    degree: "DEUST",
  },
  {
    id: 3,
    img: "lycee.png",
    school: "EL amir moulay el hassan, public school",
    date: "2017 - 2018",
    desc: "I earned my baccalaureate education in Physical Sciences.",
    degree: "Baccalaureate, Physical Sciences",
  },
]

export const projects = [
  {
    id: 0,
    title: "AI reCAPTCHA Solving Service",
    date: "2025",
    description:
    "Designed and developed an AI-powered service for automated reCAPTCHA resolution, leveraging pre-trained deep learning models for image recognition and browser automation to analyze and solve visual challenges in real time.",
    image: "demo4.png",
    tags: ["Python", "Docker", "Roboflow", "Hugginface", "Flask", "Selenium", "Tensrflow","Google Colab"],
    github: "https://github.com/NajouaBentaher/PFE-DCESS-2024-2025-2",
  },
  {
    id: 1,
    title: "Resturant Sales Dashboard",
    date: "2025",
    description:
      "A Business Intelligence dashboard designed to analyze restaurant sales performance. It provides insights into total revenue, sales quantity, top-selling items, and category performance using interactive and clear visualizations.",
    image: "project_bi.png",
    tags: ["Power BI"],
    github: "https://github.com/NajouaBentaher/BI-project-resturant-sales",
  },
  {
    id: 2,
    title: "Delivery Tracking System",
    date: "2024",
    description:
    "Developed a Java-based service for managing delivery personnel and processing customer orders, providing efficient tracking and management of deliveries and order data.",
    image: "track.png",
    tags: ["Java","MySQL"],
    github: "https://github.com/NajouaBentaher/PFE-DCESS-2024-2025-2",
  },
  {
    id: 3,
    title: "Mobile Calculator App",
    date: "2024",
    description:
      "Developed a mobile calculator application for Android, featuring a user-friendly interface and basic arithmetic operations.",
    image: "calculatrice.png",
    tags: ["Java","XML","Android SDK","Android Studio"],
    github: "https://github.com/NajouaBentaher/PFE-DCESS-2024-2025-2",
  },
  {
    id: 4,
    title: "Full-Stack Urban Land Tax Management Application (TNB)",
    date: "2023",
    description:
      "Developed a full-stack web application to manage, consult, and calculate taxes on undeveloped urban land (TNB), providing efficient data handling and accurate tax computation.",
    image: "taxe.png?height=400&width=600",
    tags: ["Angular", "Laravel", "Api", "Git", "MySQL"],
    github: "https://github.com/NajouaBentaher/PFE-DCESS-2024-2025-2",
  },
  {
    id: 5,
    title: "Insurance managemnt",
    date: "2023",
    description:
      "Developed a full-stack web application for insurance management that enables employers to manage employees and track the status of insurance folders throughout the processing lifecycle.",
    image: "insurance.png",
    tags: ["JavaScript", "Laravel", "OCR", "Tailwind CSS", "PostgreSQL"],
    github: "",
  },
 
  {
    id: 6,
    title: "E-commerce website - Marketly",
    date: "2023",
    description:
      "Full-featured e-commerce platform with product catalog, shopping cart, user authentication, and order management.",
    image: "marketly.png",
    tags: ["PHP", "JavaScript", "CSS", "MySQL", "Bootstrap"],
    github: "https://github.com/NajouaBentaher/Projet-PHP-E-marketly",
  },
  {
    id: 7,
    title: "2022 World Cup Mini Website",
    date: "2022",
    description:
      "This application is a 2022 World Cup mini website developed using HTML, Bootstrap, and JavaScript. It allows users to view groups, teams, match schedules, and player profiles. The website provides a responsive and user-friendly interface, making it easy to access essential information about the tournament and related content.",
    image: "coupe_du_monde.png",
    tags: ["HTML", "Bootstrap", "JavaScript"],
    github: "https://github.com/NajouaBentaher/Projet-HTML-CSS-JS",
  },
  {
    id: 8,
    title: "2D Video Game - PICO PARK",
    date: "2022",
    description:
      "This project involves developing a 2D platformer puzzle game inspired by PICO PARK, using the Cocos2D game engine with C++. The main goal is to apply object-oriented programming principles by creating a single-player game with at least three levels, featuring platform mechanics, puzzles, and player interactions.",
    image: "game_cpp.png",
    tags: ["C++" , "Cocos2D"],
    github: "https://github.com/NajouaBentaher/Projet-C-Game",
  },
]

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
]
